// extracted by mini-css-extract-plugin
export default {"table_div":"ChipsPanel_table_div__JGxDN","main_table":"ChipsPanel_main_table__hmF1Q","cursor_pointer":"ChipsPanel_cursor_pointer__1qLqx"};